import { useState } from 'react';
import UserPanel from './UserPanel';
import ExitLogin from './ExitLogin';

function App() {
  const [isOpenExitLogin, setIsOpenExitLogin] = useState(false);

  return (
    <>
      <div className='flex flex-col overflow-hidden bg-[#f3f3f4]'>
        <div className='flex-1 overflow-hidden drag'>
          <div className='text-center no-drag'>
            <UserPanel setIsOpenExitLogin={setIsOpenExitLogin} />
          </div>
        </div>
      </div>

      <ExitLogin isOpen={isOpenExitLogin} setIsOpen={setIsOpenExitLogin} />
    </>
  );
}

export default App;
